import { Routes } from '@angular/router';

import { SignIn } from './pages/sign-in/sign-in';
import { Dashboard } from './pages/dashboard/dashboard';
import { LotConfiguration } from './pages/lot-configuration/lot-configuration';
import { LandingCustomization } from './pages/landing-customization/landing-customization';
import { Checkout } from './pages/checkout/checkout';
import { LandingPage } from './pages/landing-page/landing-page';
import { SplashPage } from './pages/splash-page/splash-page';
import { SuccessPage } from './pages/success-page/success-page';
import { CancelledTransactionPage } from './pages/cancelled-transaction-page/cancelled-transaction-page';

export const routes: Routes = [
  { path: '', component: SplashPage },
  { path: 'landing-page/:id', component: LandingPage },
  { path: 'sign-in', component: SignIn },
  { path: 'checkout', component: Checkout },
  { path: 'success-page', component: SuccessPage },
  { path: 'cancelled-transaction', component: CancelledTransactionPage },
  { path: 'success', component: SuccessPage },
  { path: '**', component: SplashPage }
];
// { path: '', redirectTo: '', pathMatch: 'full' },
// { path: '**', redirectTo: '' },

// { path: 'dashboard', component: Dashboard },
// { path: 'lot-configuration', component: LotConfiguration },
// { path: 'checkout-customization', component: LandingCustomization },
// { path: 'landing-page/**', component: LandingPage },
// { path: '', redirectTo: '', pathMatch: 'full' },
